<span>{{ 'Category::UnusedCategoriesDeactived' | abpLocalization : categoryNames }}</span>
